module.exports = __webpack_public_path__ + "assets/teethFrontviewApart.df804b2269c4b094455f4ef3acad089e.png";